import { Grid2 } from "@mui/material";
import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import ArticleCard from "./sections/Article/ArticleCard";
import { ArticlePreview } from "../interfaces/sanity/sanityClasses";

interface Props {
  articles: {
    node: ArticlePreview;
  }[];
}

const ArticleCardGrid = ({ articles }: Props) => {
  const isMobile = useIsMobile();
  return (
    <Grid2 container={!isMobile} justifyContent="center">
      {articles.map((article, idx) => (
        <Grid2
          size={{ xs: 12, sm: 6, md: 4 }}
          key={idx}
          pl={idx === 0 || idx % 3 === 0 || isMobile ? 0 : "38px"}
          pb={{ xs: "16px", md: "24px" }}
          mt={isMobile || idx > 2 ? 2 : 0}
          display="flex"
        >
          <ArticleCard article={article?.node ?? article} />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default ArticleCardGrid;
